export const KAHVE_SINEM = [
  {
    id: "ks001",
    metin: "{{ad}}, otur şöyle karşıma. Bu fincanı görünce içim burkuldu biraz. {{soru}} konusunda seni dinleyeyim önce — ama fincan zaten anlattı bana. Yorgunsun. Hem bedenin hem ruhun yorulmuş.\n\nEn son ne zaman gerçekten dinlendin? Kendine bu soruyu sor. Fincan diyor ki: önce sen, sonra her şey. Kendin için alan açmadan başkaları için alan açamazsın.",
    tema: "yorgunluk"
  },
  {
    id: "ks002",
    metin: "{{ad}}, fincanına bakınca ilk hissettiğim şey güçlü bir enerji. {{soru}} konusunda ne kadar güçlü olduğunu unutmuşsun. Etrafındakiler senden o kadar çok şey aldı ki, kendin için ne kaldığını bilemez oldun.\n\nAma fincan gösteriyor — içinde hâlâ o güç var. Bulmak lazım sadece. Güç kaybolmaz, sadece gömülür — ve sen onu çıkarabilirsin.",
    tema: "guc"
  },
  {
    id: "ks003",
    metin: "{{ad}}, bu fincan çok şey söylüyor. {{soru}} meselesinde etrafında seni seven var, ama yanlış anlaşılmalar var aramızda. Bir konuşma, dürüst bir konuşma gerekiyor.\n\nSöylenmemiş sözler zamanla duvara dönüşüyor — yıkmadan önce konuş. O konuşmayı erteleme. Ne kadar zor görünürse görünsün, sessizlik her zaman daha ağır biter.",
    tema: "iletisim"
  },
  {
    id: "ks004",
    metin: "{{ad}}, fincanının dibinde para işareti net görünüyor. {{soru}} ne olursa olsun, maddi konularda bir rahatlama geliyor. Ama şunu ekleyeyim: bu rahatlama emekle gelecek, tesadüfle değil.\n\nHakkını ara, değerini bil. Değerini bilmeyen değer göremez. O değeri önce sen kabul et, sonra dünya da kabul eder.",
    tema: "para"
  },
  {
    id: "ks005",
    metin: "{{ad}}, fincanına baktım ve anladım — sen hep verirsin, nadiren alırsın. {{soru}} konusunda da büyük ihtimal yine başkası için düşünüyorsun.\n\nGüzel bir özellik bu, ama tüketici. Biraz da kendin için al. Biraz da kendin için iste. Vermek için dolu olmak lazım — boş kap başkasına sunamaz.",
    tema: "vermek_almak"
  },
  {
    id: "ks006",
    metin: "{{ad}}, fincanında iki farklı enerji var — bir çatışma. {{soru}} konusunda içinde de böyle bir çatışma yaşıyorsun. Bir taraf 'evet' diyor, öbür taraf 'ama'.\n\nBu 'ama'nın arkasında ne var? Onu bul, çözüm orada. 'Ama' kelimesi çoğunlukla korkunun sesidir — o korkuyu tanı, onunla konuş.",
    tema: "catisma"
  },
  {
    id: "ks007",
    metin: "{{ad}}, bu fincan bana bir ilişkiden söz ediyor. Aşk mı, dostluk mu bilmiyorum ama bir bağ var. {{soru}} konusunda bu bağ önemli bir rol oynuyor.\n\nBağın sağlıklı mı? Besliyor mu seni yoksa bitiriyor mu? Dürüst cevap ver kendine. Besleyen bağlar büyütür, bitirenler tüketir — hangisi bu?",
    tema: "iliski"
  },
  {
    id: "ks008",
    metin: "{{ad}}, fincanının kenarında bir yol var — uzun ve kıvrımlı. {{soru}} için kolay yol yok. Ama kıvrımlı yolların sonunda en güzel manzaralar var.\n\nSabret, yürü, yorulunca dur — ama bırakma. Her kıvrım seni daha ilginç kılar. Düz yollar hızlı götürür ama kıvrımlı yollar derin götürür.",
    tema: "yol"
  },
  {
    id: "ks009",
    metin: "{{ad}}, fincan bana dedikodu enerjisi gösteriyor. Etrafında konuşanlar var. {{soru}} konusunda bilmediğin şeyler söyleniyor.\n\nAma şunu söyleyeyim: konuşanlar çalışmıyor, çalışanlar konuşmuyor. Sen çalışmaya devam et. Dedikodu yapanların zamanı tükenir, çalışanların ise büyür.",
    tema: "dedikodu"
  },
  {
    id: "ks010",
    metin: "{{ad}}, bu fincan çok sıcak bir enerji taşıyor — ev, yuva, aile. {{soru}} ne olursa olsun, temel bu — aile. Bir gerginlik varsa çöz. Bir mesafe varsa kapat.\n\nFincan diyor ki: en büyük destek en yakından gelecek. Aile her zaman mükemmel değildir, ama en zorun için orada olur.",
    tema: "aile"
  },
  {
    id: "ks011",
    metin: "{{ad}}, fincanında bir sır saklı. {{soru}} konusunda bilmediğin bir gerçek var. Yakında öğreneceksin — ve önce şaşıracaksın, sonra anlayacaksın, en son kabul edeceksin.\n\nBu süreci atlatmak zor ama atlatılır. Her gerçek önce şok gibi gelir, sonra özgürleştirir.",
    tema: "gercek"
  },
  {
    id: "ks012",
    metin: "{{ad}}, fincan bana şunu söylüyor: sen çok affediyorsun. {{soru}} konusunda da yine affedecek misin diye düşünüyorsundur.\n\nAffetmek kalp için güzel, ama sınır çizmek de gerekli. İkisini birden yapabilirsin. Affedersin — ama aynı hatanın tekrar yaşanacağı ortamı yaratmadan.",
    tema: "affetmek"
  },
  {
    id: "ks013",
    metin: "{{ad}}, fincanının ortasında güçlü bir çizgi var — bu kararlılık demek. {{soru}} konusunda bir karar verdin mi henüz?\n\nFincan diyor ki: karar verme vakti geldi. Daha fazla erteleme. Her ertelenen karar, bir sonraki kararı da zorlaştırır. Bugün ver — küçük de olsa.",
    tema: "karar"
  },
  {
    id: "ks014",
    metin: "{{ad}}, fincan bana sağlık enerjisi gösteriyor. {{soru}} ne olursa olsun, bedenini ihmal etme. Kontrollerini yaptır, dinlen, beslen.\n\nKendinle ilgilen. Sağlam beden, güçlü zihin demektir. Ve güçlü zihin, her sorunu daha kolay çözer.",
    tema: "saglik"
  },
  {
    id: "ks015",
    metin: "{{ad}}, fincanında bir kadın silüeti var — güçlü duruyor. Bu sensin. {{soru}} konusunda belki zayıf hissediyorsun ama fincan başka bir şey görüyor.\n\nDik dur. Omuzlarını indir. Başını kaldır. Duruş, hissin önüne geçer — önce dik dur, his sonra gelir.",
    tema: "ozguven"
  },
  {
    id: "ks016",
    metin: "{{ad}}, fincan bana iş ortamından söz ediyor. {{soru}} konusunda iş yerinde bir değişim rüzgarı esiyor.\n\nHazırlıklı ol — bu değişim seni olumsuz etkilemeyecek, tam tersine fırsat yaratacak. Değişimden korkan geride kalır, değişimi kucaklayan öne geçer.",
    tema: "is"
  },
  {
    id: "ks017",
    metin: "{{ad}}, fincanında çok güzel bir şey var — bereket tohumu. {{soru}} ne olursa olsun, ektiğin tohumlar meyve verecek.\n\nAma hasat için sabır lazım. Meyve zamanından önce koparılırsa, ne tadı olur ne faydası. Zamanını bekle — olgunlaşmış meyve en tatlısıdır.",
    tema: "bereket"
  },
  {
    id: "ks018",
    metin: "{{ad}}, fincan bana bir yolculuktan söz ediyor. {{soru}} konusunda belki fiziksel bir yolculuk, belki hayatında yeni bir sayfa.\n\nHer iki durumda da hazırlıklı ol. Yolculuklar bazen yön değiştirir — ama hep bir şeyler öğretir. O öğrenmeye açık ol.",
    tema: "yolculuk"
  },
  {
    id: "ks019",
    metin: "{{ad}}, fincanında bir kelebek şekli var. Dönüşüm, değişim, güzelleşme. {{soru}} konusunda sen de bir dönüşüm içindesin.\n\nKelebek olmadan önce koza dönemini yaşamak gerekir. Şu an koza dönemindeysen, sabret — kanatlar geliyor. Koza karanlık görünür ama içinde mucize hazırlanır.",
    tema: "donusum"
  },
  {
    id: "ks020",
    metin: "{{ad}}, fincan bana bir müjde veriyor — ama sabır istiyor. {{soru}} konusunda beklediğin iyi haber gelecek.\n\nNe zaman? Fincan tam tarih vermiyor ama yakın diyor. Umudu kesme. Son karanlık, şafaktan önceki karanlıktır.",
    tema: "mujde"
  },
  {
    id: "ks021",
    metin: "{{ad}}, fincanında bir göz şekli var. Bu sezgi ve farkındalık demek. {{soru}} konusunda gördüğün ama görmezden geldiğin bir şey var.\n\nO şeyi artık görmezden gelme zamanı geçti. Yüzleş. Görmezden gelinen şeyler büyür — yüzleşilenler ise küçülür.",
    tema: "farkındalık"
  },
  {
    id: "ks022",
    metin: "{{ad}}, fincan bana arkadaşlık enerjisi gösteriyor. {{soru}} konusunda yalnız hissediyorsun ama değilsin.\n\nGerçek bir dost seni düşünüyor — belki uzakta, belki yakında. Ona ulaş, o da sana uzanmak istiyor. Bazen ilk adımı atmak yeterli — karşılık kendiliğinden gelir.",
    tema: "dostluk"
  },
  {
    id: "ks023",
    metin: "{{ad}}, fincanının sağ tarafı parlak. Bu gelecek demek — ve parlak görünüyor. {{soru}} ne kadar ağır gelse de, fincan bana şunu söylüyor: bu dönem geçiyor.\n\nDaha iyi günler sadece köşe başında. O köşeyi dönmek için biraz daha yürümek lazım. Yürü.",
    tema: "umut"
  },
  {
    id: "ks024",
    metin: "{{ad}}, fincan bana çok şey anlattı bugün. {{soru}} konusunda şunu söyleyeyim: sen hak ediyorsun. İyi şeyleri hak ediyorsun. Mutluluğu hak ediyorsun.\n\nAma bunu inanarak söylüyorum — önce sen inan buna. Hak ettiğine inanmayan, hak ettiklerini de uzaklaştırır. O inancı kazan önce.",
    tema: "hak_etmek"
  },
  {
    id: "ks025",
    metin: "{{ad}}, şunu söyleyeyim: bu fincan seni çok sevdi. Güzel enerji taşıyorsun. {{soru}} ne olursa olsun, içindeki o ışığı söndürme.\n\nKaranlık ne kadar yoğun olursa olsun, küçük bir ışık her şeyi değiştirir. Sen o ışıksın. Ve ışık, karanlığı yok etmek zorunda değildir — sadece var olmak yeterlidir.",
    tema: "isik"
  }
];